import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import Highcharts from 'highcharts';

// 代碼根據 open-meteo api weather_code
// https://open-meteo.com/en/docs?hourly=temperature_2m,weather_code,precipitation_probability#weather_variable_documentation
var weatherImgMap = {
  0: '01d',
  1: '02d',
  2: '02d',
  3: '02d',
  45: '50d',
  48: '50d',
  51: '09d',
  53: '09d',
  55: '09d',
  56: '09d',
  57: '09d',
  61: '09d',
  63: '09d',
  65: '09d',
  66: '09d',
  67: '09d',
  71: '13d',
  73: '13d',
  75: '13d',
  77: '13d',
  80: '11d',
  81: '11d',
  82: '11d',
  85: '13d',
  86: '13d',
  96: '11d',
  99: '11d'
};

// PV Charts -----------------------------------------------------------------
// 每小時發電/日照圖
function weatherBuildComboOptions(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 1400 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 320 : _ref$height,
    title = _ref.title,
    categories = _ref.categories,
    acpData = _ref.acpData,
    weatherData = _ref.weatherData,
    irrData = _ref.irrData,
    prData = _ref.prData;
  var currentHour = dayjs().format('HH') + ':00';
  var currentIndex = categories.findIndex(function (label) {
    return label === currentHour;
  });
  return {
    chart: {
      width: width,
      height: height
    },
    title: {
      text: title
    },
    xAxis: [{
      categories: categories,
      plotLines: currentIndex >= 0 ? [{
        color: '#d65d5d',
        width: 2,
        value: currentIndex,
        zIndex: 5,
        label: {
          text: '現在時間',
          align: 'center',
          rotation: 0,
          x: 0,
          y: -10,
          style: {
            color: '#d65d5d',
            fontWeight: 'bold'
          }
        }
      }] : []
    }],
    yAxis: [{
      labels: {
        format: '{value} °C'
      }
    }, {
      labels: {
        format: '{value} kWh',
        style: {
          color: '#0582f7'
        }
      },
      opposite: true
    }],
    tooltip: {
      // backgroundColor: '#ffffff',
      valueDecimals: undefined,
      useHTML: true // 確保渲染到 DOM 外層
      // zIndex: 9999 // 強制比 dataLabels 高
    },
    series: [{
      name: '發電量',
      type: 'column',
      yAxis: 1,
      data: acpData,
      tooltip: {
        valueSuffix: ' kWh'
      }
    }, {
      name: '日照量',
      type: 'spline',
      data: irrData,
      tooltip: {
        valueSuffix: ' kWh/m²'
      }
    }, {
      name: 'PR',
      type: 'spline',
      data: prData,
      tooltip: {
        valueSuffix: ' %'
      }
    }, {
      name: '溫度',
      type: 'spline',
      data: weatherData,
      tooltip: {
        valueSuffix: ' °C'
      },
      style: {
        textOutline: 'none',
        fontSize: '12px'
      },
      dataLabels: {
        enabled: true,
        useHTML: true,
        formatter: function formatter() {
          var imageUrlNo = weatherImgMap[this.point.weatherCode] || '';
          var src = imageUrlNo ? require("../../../../assets/weather/".concat(imageUrlNo, ".png")) : '';
          return "<div style=\"color:#e9e9e9;margin-bottom:10px;z-index:0\">\n              <img width=30 height=30 style=\"opacity:0.9\" src=\"".concat(src, "\" />\n            <div style=\"font-size:13px\">").concat(this.y, " <span style=\"font-size:10px\">\xB0C</span></div>\n            </div>");
        }
      }
    }]
  };
}

// 峰瓩值熱圖
function buildHeatmapOptions(_ref2) {
  var _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? 680 : _ref2$width,
    _ref2$height = _ref2.height,
    height = _ref2$height === void 0 ? 320 : _ref2$height,
    title = _ref2.title,
    xCats = _ref2.xCats,
    yCats = _ref2.yCats,
    data = _ref2.data;
  return {
    chart: {
      type: 'heatmap',
      width: width,
      height: height
    },
    title: {
      text: title
    },
    xAxis: {
      categories: xCats,
      tickWidth: 1,
      tickInterval: 4
    },
    yAxis: {
      categories: yCats,
      // reversed: true,
      // min: 0,
      // max: yCats.length - 1,
      title: {
        text: null
      }
    },
    colorAxis: {
      stops: [[0, '#2047A7'], [0.15, '#2DAAD8'], [0.3, '#ABD89D'], [0.5, '#FCE970'], [0.85, '#F3874D'], [1, '#C04834']],
      width: 250,
      min: 0,
      max: 0.25,
      startOnTick: true,
      endOnTick: true,
      labels: {
        format: '{value}',
        style: {
          color: '#e9e9e9'
        }
      }
    },
    tooltip: {
      formatter: function formatter() {
        return '<b>' + this.series.xAxis.categories[this.point.x] + '</b>&ensp;' + this.series.yAxis.categories[this.point.y] + '<br><b>峰瓩值: ' + this.point.value + ' (kW/kWp)</b>';
      }
    },
    series: [{
      data: data
    }]
  };
}

// 每日發電/日照圖
function buildComboOptions(_ref3) {
  var _ref3$width = _ref3.width,
    width = _ref3$width === void 0 ? 680 : _ref3$width,
    _ref3$height = _ref3.height,
    height = _ref3$height === void 0 ? 320 : _ref3$height,
    title = _ref3.title,
    categories = _ref3.categories,
    acpData = _ref3.acpData,
    irrData = _ref3.irrData;
  return {
    chart: {
      width: width,
      height: height
    },
    title: {
      text: title
    },
    xAxis: {
      categories: categories
    },
    yAxis: [{
      labels: {
        format: '{value} kWh/m²'
      }
    }, {
      labels: {
        format: '{value} kWh',
        style: {
          color: '#0582f7'
        }
      },
      opposite: true
    }],
    series: [{
      name: '發電量',
      type: 'column',
      yAxis: 1,
      data: acpData,
      tooltip: {
        valueSuffix: ' kWh'
      },
      dataLabels: {
        format: '{y} kWh',
        style: {
          color: '#82d4f5',
          textOutline: 'none'
        }
      }
    }, {
      name: '日照量',
      type: 'spline',
      data: irrData,
      tooltip: {
        valueSuffix: ' kWh/m²'
      },
      dataLabels: {
        format: '{y} kWh/m²',
        style: {
          color: '#e9e9e9',
          textOutline: 'none'
        }
      }
    }]
  };
}

// Electricity Charts -----------------------------------------------------------------
// 每日電錶用電比較
function buildStackedColumnOptions(_ref4) {
  var _ref4$width = _ref4.width,
    width = _ref4$width === void 0 ? 1400 : _ref4$width,
    _ref4$height = _ref4.height,
    height = _ref4$height === void 0 ? 320 : _ref4$height,
    title = _ref4.title,
    categories = _ref4.categories,
    series = _ref4.series;
  return {
    chart: {
      type: 'column',
      width: width,
      height: height
    },
    title: {
      text: title
    },
    xAxis: {
      categories: categories
    },
    yAxis: {
      labels: {
        format: "{value} kWh"
      },
      stackLabels: {
        enabled: true,
        format: '{total:.2f}' // 保留 2 位小數
      }
    },
    legend: {
      // x: 0,
      // y: 0,
      align: 'right',
      verticalAlign: 'top',
      floating: true,
      backgroundColor: '#3b4f62',
      borderColor: '#e9e9e9',
      borderWidth: 1,
      shadow: false
    },
    tooltip: {
      headerFormat: '<b>{point.key}</b><br/>',
      pointFormatter: function pointFormatter() {
        return "<span style=\"color:".concat(this.color, "\">\u25CF</span>\n                ").concat(this.series.name, ":&ensp;\n                <b>").concat(Highcharts.numberFormat(this.y, 2), "</b>\n                &ensp;kWh<br/>");
      },
      footerFormat: '<span>Total:&ensp;<b>{point.total:.2f}</b>&ensp;kWh</span>'
      // 同 point.stackTotal (stackLabels 已有 format)
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f}' // 保留 2 位小數
          // formatter: function () {
          //   return Highcharts.numberFormat(this.y, 2) + ' kWh'
          // }
        }
      }
    },
    series: series
  };
}

// 今日電錶功率比較
function buildScatterOptions(_ref5) {
  var _ref5$width = _ref5.width,
    width = _ref5$width === void 0 ? 680 : _ref5$width,
    _ref5$height = _ref5.height,
    height = _ref5$height === void 0 ? 320 : _ref5$height,
    title = _ref5.title,
    series = _ref5.series;
  return {
    chart: {
      type: 'scatter',
      width: width,
      height: height
    },
    title: {
      text: title
    },
    xAxis: {
      type: 'datetime',
      labels: {
        format: '{value:%H:%M}'
      }
    },
    yAxis: {
      labels: {
        format: "{value} kW"
      }
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 2.5,
          symbol: 'circle',
          states: {
            hover: {
              enabled: true,
              lineColor: 'rgb(100,100,100)'
            }
          }
        },
        states: {
          hover: {
            marker: {
              enabled: false
            }
          }
        }
      }
    },
    tooltip: {
      headerFormat: "<span style=\"color:{series.color}\">\u25CF</span> {series.name}<br/>",
      pointFormat: "\u6642\u9593: <b>{point.x:%H:%M}</b><br/>\u529F\u7387: <b>{point.y} kW</b>"
    },
    series: series
  };
}

// 今日電錶功率因素
function buildMonthlySplineOptions(_ref6) {
  var _ref6$width = _ref6.width,
    width = _ref6$width === void 0 ? 680 : _ref6$width,
    _ref6$height = _ref6.height,
    height = _ref6$height === void 0 ? 320 : _ref6$height,
    title = _ref6.title,
    categories = _ref6.categories,
    series = _ref6.series;
  return {
    chart: {
      type: 'spline',
      width: width,
      height: height
    },
    title: {
      text: title
    },
    xAxis: {
      categories: categories
    },
    plotOptions: {
      spline: {
        marker: {
          radius: 4,
          lineColor: '#666666',
          lineWidth: 1
        }
      }
    },
    series: series
  };
}
export var modalChartRenderers = {
  solarInfo: [weatherBuildComboOptions, buildHeatmapOptions, buildComboOptions],
  mysqlInfo: [],
  powerInfo: [buildStackedColumnOptions, buildScatterOptions, buildMonthlySplineOptions]
};